"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryNodeEventObject = exports.StoryNode = void 0;
const class_transformer_1 = require("class-transformer");
const Eventbus_1 = require("../../cutil/Eventbus");
const JsonUtil_1 = require("../../cutil/JsonUtil");
const StoryNodeState_1 = require("../../storyV2/domain/StoryNodeState");
const SearchInfoWrapper_1 = require("../../storyV2/model/SearchInfoWrapper");
const StoryLine_1 = require("./StoryLine");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class StoryNode {
    constructor(options) {
        this.options = options;
        this.state = StoryNodeState_1.StoryNodeState.IDLE;
        this.lines = [];
        this.originContent = "";
        this.content = "";
        this.children = [];
        this.isInput = false;
        this._eventbus = new Eventbus_1.Eventbus();
        this.id = options.id;
    }
    /// node本身连出去的边
    edges() {
        return this.lines.map(e => e.target);
    }
    /// node内所有连出的边，包含子节点连出去的
    allEdges() {
        return [...this.edges(), ...this.children.flatMap(e => e.allEdges())];
    }
    reset() {
        this.state = StoryNodeState_1.StoryNodeState.IDLE;
        this.originContent = "";
        this.content = "";
        this.children.forEach(childNode => childNode.reset());
    }
    /**
     * 找到当前所有相关的子节点
     */
    findChildren() {
        let result = [...this.children];
        const childChild = this.children.flatMap(childNode => childNode.findChildren());
        result.push(...childChild);
        return result;
    }
    cleanChildren() {
        const lines = this.children
            .map((value, index, array) => {
            if (value.lines.length != 0) {
                const disconnectedLine = new StoryLine_1.StoryDisconnectedLine(this.options.id, index, value.lines);
                return disconnectedLine;
            }
            return undefined;
        })
            .filter(e => e != undefined);
        this.children = [];
        return lines;
    }
    resetState() {
        this.state = StoryNodeState_1.StoryNodeState.IDLE;
    }
    setLoading() {
        this.state = StoryNodeState_1.StoryNodeState.LOADING;
        this.children.forEach(x => x.setLoading());
    }
    setCompleted() {
        this.state = StoryNodeState_1.StoryNodeState.COMPLETED;
        this.children.forEach(x => x.setCompleted());
    }
    on(listener) {
        this._eventbus.on(StoryNodeEventObject, result => {
            listener(result);
        }, true);
        const that = this;
        return {
            off() {
                that.off(listener);
            },
        };
    }
    off(listener) {
        this._eventbus.off(StoryNodeEventObject, listener);
    }
    received(result) {
        if (typeof result.content === "string") {
            this.content = result.content;
        }
        else {
            this.children = result.content;
        }
        this._eventbus.emit(result);
    }
    parseContent(modelType) {
        if (this.content === "") {
            return undefined;
        }
        return JsonUtil_1.JsonUtil.toModelFromType(modelType, this.content);
    }
    /// 对于有加载更多的数据类型，特有的取商品数据的方法
    /// 因为这种数据会被包装为SearchInfoWrapper，用于存储分页相关的信息
    parseSearchData(modelType) {
        const searchInfo = this.parseContent((SearchInfoWrapper_1.SearchInfoWrapper));
        /// 以下代码是为了解决范围结果类型并不是传进来的T类型的问题
        /// 通过model转json再转model来解决
        const result = searchInfo?.result || [];
        const plain = (0, class_transformer_1.instanceToPlain)(result);
        const stronglyTypedResult = (0, class_transformer_1.plainToInstance)(modelType, plain);
        return stronglyTypedResult;
    }
    /// 对于有加载更多的数据类型，特有的取商品搜索关键字的方法
    parseSearchKey() {
        const searchInfo = this.parseContent((SearchInfoWrapper_1.SearchInfoWrapper));
        return searchInfo?.searchKey || "";
    }
    parseContentToArray(modelType) {
        return JsonUtil_1.JsonUtil.toArrayFromType(modelType, this.content);
    }
    childIds() {
        return this.children.map(n => {
            if (!(0, is_blank_1.default)(n.id) && n.id !== "") {
                return n.id;
            }
            return n.options.id;
        });
    }
    /**
     * 查找最后一个node，通过主线连出去的，找到第一根主线
     */
    findLastNode() {
        const last = this.lines.map(x => x.target.targetNode()?.findLastNode()).first();
        return last ?? this;
    }
    /**
     * 查找最后一个edge，通过主线链接出去的，找到第一根主线
     */
    findLastEdge() {
        const last = this.edges().first()?.findLastEdge();
        return last;
    }
}
exports.StoryNode = StoryNode;
class StoryNodeEventObject {
    constructor(content) {
        this.content = content;
        this.naming = "StoryNodeEventObject";
    }
}
exports.StoryNodeEventObject = StoryNodeEventObject;
